
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as newsEdum3lWxEfTsFRnHlwP2fDM7dXHl__ocjxc0P0NFIfIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/news.vue?macro=true";
import { default as indexkYNTKHirawm1ZEkazR7X61M2ltaRqQjv7EZ6t08gZskMeta } from "C:/laragon/www/pergiyuks-frontend/pages/index.vue?macro=true";
import { default as invitey6RUH9TMTxGVXIxGOwYAgo7HD6Yf0wT4iOg98jd2jD4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/invite.vue?macro=true";
import { default as policyDVNm6hZqXFpINt6EbFnN8MqD9rE637Py2SptSP2cPAwMeta } from "C:/laragon/www/pergiyuks-frontend/pages/policy.vue?macro=true";
import { default as profilev1LbJPR7vBhHBZxLBiMGSIvFxBpfbxPYTNvbegR1yfkMeta } from "C:/laragon/www/pergiyuks-frontend/pages/profile.vue?macro=true";
import { default as securityG2_45q0awr7jInpLm3omX_uyQzXCD2qFLmdHSVZsijZZAMeta } from "C:/laragon/www/pergiyuks-frontend/pages/security.vue?macro=true";
import { default as carabayarRnMa86w3ijcpfeQCYoQnNk2D2ch600pyZ1usAUJ4RqEMeta } from "C:/laragon/www/pergiyuks-frontend/pages/carabayar.vue?macro=true";
import { default as contact_45usCRSYrGeQhpeXMnNB30u3xU43AuQj38UXoCZOBTrS_45iIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/contact-us.vue?macro=true";
import { default as indexnfIEszvkKdrexDh7HY6KVKVIPPUikOkRPtQUkrei39EMeta } from "C:/laragon/www/pergiyuks-frontend/pages/ppob/index.vue?macro=true";
import { default as indexvZyH9Q5kj9Zb4GM_45ZSOiUy1aQbkY8nqmNzaPpXkNgtYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/pelni/index.vue?macro=true";
import { default as seatCqEHNWJjZcUQHOKeeaNs4CoFUHKrNt8Ep5z0skJSSW0Meta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/seat.vue?macro=true";
import { default as indexUQ_gtAJcZfrYmHvSZZrL6ktwdAHMs7nPmlQ17QM24x8Meta } from "C:/laragon/www/pergiyuks-frontend/pages/hotels/index.vue?macro=true";
import { default as reportsVLAGvTEWBmCGeFTl8PL5nG6LLNSYE_45zADFHTNAp6SFIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/ppob/reports.vue?macro=true";
import { default as indexqiKvCznNV39VHKyPsEvJLeaGCuvbZCwSFKsAP8i4TbAMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/index.vue?macro=true";
import { default as detailTHLMaumq0GrDm8dKCSet4aAEOwxXdJKTm20d8UzRNtIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/hotels/detail.vue?macro=true";
import { default as searchFrK8ZKtVMBsYWF0_45dEAPUDExDf3xLL2Cf3Szcv7xbVwMeta } from "C:/laragon/www/pergiyuks-frontend/pages/hotels/search.vue?macro=true";
import { default as pricebUkjxQqYr_451kauRpzmXomP64NOPE0Le2_45JadnoZOOj8Meta } from "C:/laragon/www/pergiyuks-frontend/pages/markups/price.vue?macro=true";
import { default as indexGgs5R_45DRdeLxMyRbgJiMXpK5dBPkmG_4576sHhZ2PUSuoMeta } from "C:/laragon/www/pergiyuks-frontend/pages/partner/index.vue?macro=true";
import { default as indexFgw6Lyor3vzjY8p63_45rGnHwESdEoyrW6ghCF45nMSeYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/payment/index.vue?macro=true";
import { default as reportsDA_45wMVdZ7SZN34ualZeD3QtDitlBQFWek9DvkGpY810Meta } from "C:/laragon/www/pergiyuks-frontend/pages/pelni/reports.vue?macro=true";
import { default as term_45paymentskynxjnXQHJfAf99zWxSzarXPcJ1tXvkndD5VcNlsG88Meta } from "C:/laragon/www/pergiyuks-frontend/pages/term-payments.vue?macro=true";
import { default as indexeYl4BfuqyaRHuoRQFOryLzDP0ms6Nt49ceaiRRYVbYcMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/index.vue?macro=true";
import { default as delete_45accountlC_85MSKWUmQSqOBmjIClwe2niIEnqKpY39bLKTSq7gMeta } from "C:/laragon/www/pergiyuks-frontend/pages/delete-account.vue?macro=true";
import { default as payment05MfFhAEUcB_45dk1yKn6borBSY4vsyGzS4QG8nJolTAYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/hotels/payment.vue?macro=true";
import { default as reportsD9HLL9rNbXottgPAZC0mjrKYgQZNFQPV9XE497qi_45OYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/hotels/reports.vue?macro=true";
import { default as addpCPXkBUuHpusBndrXUZPneRWGLvnOzaj5t9tGXzta0kMeta } from "C:/laragon/www/pergiyuks-frontend/pages/passengers/add.vue?macro=true";
import { default as schedule0svq1roDWYFI5D3v7iipsUB2u0TijmbZZVyIyEDViPkMeta } from "C:/laragon/www/pergiyuks-frontend/pages/pelni/schedule.vue?macro=true";
import { default as _servicesKo6QKwB0sCVNLJ8DqKiJ5B9O5YrbWeZmR4txeWPHvWgMeta } from "C:/laragon/www/pergiyuks-frontend/pages/ppob/_services.vue?macro=true";
import { default as privacy_45policy1oZYdVnFEGcRSidP7Waj43O_45BCOsCfxLJ6IHyuXaniIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/privacy-policy.vue?macro=true";
import { default as biodata5mISjjQzQ5F61CvdYR_LDaemm9pyHnUO403pSGzJhhAMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/biodata.vue?macro=true";
import { default as confirmtuAC8COMNJVrt4a6tb1_2_K2rimdsmcfYXWf9WfgM8cMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/confirm.vue?macro=true";
import { default as paymentWfkDoC_Dn_JfPGib4tmPSDTH8G1V_QvUGgyNfRQb5GYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/payment.vue?macro=true";
import { default as reportsalidDAk11e9OJRhIl6YEDWGnK_45i9u47M06bXh7fHYqYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/reports.vue?macro=true";
import { default as rebookWkPWdJnA6X_45F6PyjDuxsEX5QD3LWqiiz9Ur5YXcyw8gMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/rebook.vue?macro=true";
import { default as editLkniLakB5EOrTRaVgZ2ydzt3J0YJRN71BZ4PVsQJ0SkMeta } from "C:/laragon/www/pergiyuks-frontend/pages/passengers/edit.vue?macro=true";
import { default as schedulenG_45uDMLQ13SkFDEWrN5vYYpraPy38CJ7dKR1TpXALFQMeta } from "C:/laragon/www/pergiyuks-frontend/pages/trains/schedule.vue?macro=true";
import { default as paymentgFnuSrUw_45iHI3T24Rgy8NH0jqqexpNmaEiNdRC7fDWQMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/payment.vue?macro=true";
import { default as reportsKiojJc8WhU5NOvPq2jgh9X8_tZhJoksHP_8UdkMa5B0Meta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/reports.vue?macro=true";
import { default as fallbackuT35tVuNiK4upZ2Kl2mzIY6UxHdZ18Pwhc9E4_45fpKSgMeta } from "C:/laragon/www/pergiyuks-frontend/pages/partner/fallback.vue?macro=true";
import { default as indexdaReABXFbCkSTUoZ7XSgoPaDQ0zVIJIxBXECKVirkPIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/passengers/index.vue?macro=true";
import { default as indexWd9amGPDGf8kZ8Cd4Jbjz74WXqwWKyI29JrQLiTcVm0Meta } from "C:/laragon/www/pergiyuks-frontend/pages/subaccount/index.vue?macro=true";
import { default as subresellern_45ezL9p2NcDcPLpKS6w8a46iW3CN9ha7bDAd79zE3gcMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/subreseller.vue?macro=true";
import { default as scheduleszvZvxwIlGlzSSatJVEhL0cQDRaJohdiScDOFerg0qMsMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/schedules.vue?macro=true";
import { default as historieslareSUX01pfaosyNISPt2Ftlv_pq25MCP_45WXVamE7V8Meta } from "C:/laragon/www/pergiyuks-frontend/pages/deposits/histories.vue?macro=true";
import { default as bpjsmkqp6s2Yi0gm5MiSv0d62hhVhnObElEYkQffBOFDT8AMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/bpjs.vue?macro=true";
import { default as pdamr_45zlX5xQV76UetFfAlneU7SSII6AG_rnt_s_45yq37c1kMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pdam.vue?macro=true";
import { default as sentry_45example_45page1pKqisfb3cpEDsGsqUOy5u8Bffsw82YVr_9qcba4qNYMeta } from "C:/laragon/www/pergiyuks-frontend/pages/sentry-example-page.vue?macro=true";
import { default as web_checkin2wsRZjjb2oofy5iM8s3JhVC3ZaitPprGhNyFjCwShuUMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/web_checkin.vue?macro=true";
import { default as gamesVbzI_tgSUDCV_45R5Fl7YxzqRLDhqx2B8IIToBLoepkSQMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/games.vue?macro=true";
import { default as subreseller_addknU6lbNbS466SRfXY_PYRVrhbFfCLZLOiZK6G_x2y_0Meta } from "C:/laragon/www/pergiyuks-frontend/pages/users/subreseller_add.vue?macro=true";
import { default as indexmT2WOR7lpHJz6XEItgTLl2nGjsjxcr8_PelhrBVGjh4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/index.vue?macro=true";
import { default as e_45moneyhkqAMXypXNzjrLABbUNON2YMzFioMTS1WydpgOZm0IAMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/e-money.vue?macro=true";
import { default as ppobKi8W41g6FaoHnHJb81k50ISxi_458tzIBDKrktyLEkO8gMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/ppob.vue?macro=true";
import { default as subreseller_editkchDkD_45Zh2AUqvl71MTJf6LfkwLNL4F5PRgbAwcJ0G4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/users/subreseller_edit.vue?macro=true";
import { default as rebook_45reportswzHHRwAi3s_W_Rnwqv6sXA1jV9Ov7kQdV9utQ7OHqZgMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/rebook-reports.vue?macro=true";
import { default as refund_45reportss1oq30BP19vujzYOssyyupuXOo1wQTxScgxs4JOitC4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/refund-reports.vue?macro=true";
import { default as e_45walletK6BXAwHrtQ2pKTZskg6TK8QE6CZR6YUojWSR0gIEVYcMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/e-wallet.vue?macro=true";
import { default as hotelDjKO4ev4GQC_7EcVtx7c9qWO_45GavJszQOd_45AV0Tb2dAMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/hotel.vue?macro=true";
import { default as pelni3WFTh_9UNux1oBu6breeUVLH8HZZs2e1TX83ggGKeOQMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/pelni.vue?macro=true";
import { default as trainwqrvG_45Jozjwa9oPpCZk5d_T2BDL9djbEyxaW8GFSIioMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/train.vue?macro=true";
import { default as paymentXBeQ8LsNqfM2ElzYbMWMAHxpBeUizo_BY_451lcm1_s5wMeta } from "C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/payment.vue?macro=true";
import { default as rebookbEP46YuHd_9pd5XVX7UXYbMNfMnbd_45q0oP11jeBu5w4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/multicity/rebook.vue?macro=true";
import { default as pulsa_45data_45dt9PaSfVLW_45xvkSCPxc0l94AzJAk1Fl_45ZiLGdh6HWgMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pulsa-data.vue?macro=true";
import { default as tagihan_45tv_45cEORBny5ROk6ev7GRkdt5OWFuVOrgcq0YYSY1QIG08Meta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-tv.vue?macro=true";
import { default as historiesj3Iz5dZreiElwTKSy24jNeO7aYp_4508g1BoO_5UX5bUIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/histories.vue?macro=true";
import { default as airlines7TzWox1Rzk1JkArZjzeb_45woYrG5IWcS_45use5aKq66psMeta } from "C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/airlines.vue?macro=true";
import { default as multifinanceQW25S3pvyeTS3uCO28oi78qn_QM_45oSmipbo5uA7Y_KIMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/multifinance.vue?macro=true";
import { default as pln_45prabayarOXRtDWI7gnwSru1LqWCM6s5kLZS36HEPcH_Xivw6lw8Meta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pln-prabayar.vue?macro=true";
import { default as schedulesEyr89AbE6cvg8lOIg1qwi6eXD3B0xQ9weDojq5VGu5EMeta } from "C:/laragon/www/pergiyuks-frontend/pages/airlines/multicity/schedules.vue?macro=true";
import { default as pln_45pascabayar_4529yuv8DVaixx9hiQ1mXClLc4M6LjZsnBSG97TZzck8Meta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pln-pascabayar.vue?macro=true";
import { default as tagihan_45teleponsPTYWGTxAL49CSCoRPCoyHGAzGJeeIuSyZoMnSG3nHgMeta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-telepon.vue?macro=true";
import { default as tagihan_45internetjr5RM46CSbeQDzPqOLk6XFu2PXevQ59fNWnrMoHB4x4Meta } from "C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-internet.vue?macro=true";
export default [
  {
    name: "news",
    path: "/news",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/index.vue")
  },
  {
    name: "invite",
    path: "/invite",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/invite.vue")
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/policy.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/profile.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/security.vue")
  },
  {
    name: "carabayar",
    path: "/carabayar",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/carabayar.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/contact-us.vue")
  },
  {
    name: "ppob",
    path: "/ppob",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/ppob/index.vue")
  },
  {
    name: "pelni",
    path: "/pelni",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/pelni/index.vue")
  },
  {
    name: "trains-seat",
    path: "/trains/seat",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/seat.vue")
  },
  {
    name: "hotels",
    path: "/hotels",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/hotels/index.vue")
  },
  {
    name: "ppob-reports",
    path: "/ppob/reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/ppob/reports.vue")
  },
  {
    name: "trains",
    path: "/trains",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/index.vue")
  },
  {
    name: "hotels-detail",
    path: "/hotels/detail",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/hotels/detail.vue")
  },
  {
    name: "hotels-search",
    path: "/hotels/search",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/hotels/search.vue")
  },
  {
    name: "markups-price",
    path: "/markups/price",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/markups/price.vue")
  },
  {
    name: "partner",
    path: "/partner",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/partner/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/payment/index.vue")
  },
  {
    name: "pelni-reports",
    path: "/pelni/reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/pelni/reports.vue")
  },
  {
    name: "term-payments",
    path: "/term-payments",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/term-payments.vue")
  },
  {
    name: "airlines",
    path: "/airlines",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/index.vue")
  },
  {
    name: "delete-account",
    path: "/delete-account",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/delete-account.vue")
  },
  {
    name: "hotels-payment",
    path: "/hotels/payment",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/hotels/payment.vue")
  },
  {
    name: "hotels-reports",
    path: "/hotels/reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/hotels/reports.vue")
  },
  {
    name: "passengers-add",
    path: "/passengers/add",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/passengers/add.vue")
  },
  {
    name: "pelni-schedule",
    path: "/pelni/schedule",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/pelni/schedule.vue")
  },
  {
    name: "ppob-_services",
    path: "/ppob/_services",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/ppob/_services.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/privacy-policy.vue")
  },
  {
    name: "trains-biodata",
    path: "/trains/biodata",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/biodata.vue")
  },
  {
    name: "trains-confirm",
    path: "/trains/confirm",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/confirm.vue")
  },
  {
    name: "trains-payment",
    path: "/trains/payment",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/payment.vue")
  },
  {
    name: "trains-reports",
    path: "/trains/reports",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/reports.vue")
  },
  {
    name: "airlines-rebook",
    path: "/airlines/rebook",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/rebook.vue")
  },
  {
    name: "passengers-edit",
    path: "/passengers/edit",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/passengers/edit.vue")
  },
  {
    name: "trains-schedule",
    path: "/trains/schedule",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/trains/schedule.vue")
  },
  {
    name: "airlines-payment",
    path: "/airlines/payment",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/payment.vue")
  },
  {
    name: "airlines-reports",
    path: "/airlines/reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/reports.vue")
  },
  {
    name: "partner-fallback",
    path: "/partner/fallback",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/partner/fallback.vue")
  },
  {
    name: "passengers",
    path: "/passengers",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/passengers/index.vue")
  },
  {
    name: "subaccount",
    path: "/subaccount",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/subaccount/index.vue")
  },
  {
    name: "users-subreseller",
    path: "/users/subreseller",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/subreseller.vue")
  },
  {
    name: "airlines-schedules",
    path: "/airlines/schedules",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/schedules.vue")
  },
  {
    name: "deposits-histories",
    path: "/deposits/histories",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/deposits/histories.vue")
  },
  {
    name: "produk-digital-bpjs",
    path: "/produk-digital/bpjs",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/bpjs.vue")
  },
  {
    name: "produk-digital-pdam",
    path: "/produk-digital/pdam",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pdam.vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/sentry-example-page.vue")
  },
  {
    name: "airlines-web_checkin",
    path: "/airlines/web_checkin",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/web_checkin.vue")
  },
  {
    name: "produk-digital-games",
    path: "/produk-digital/games",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/games.vue")
  },
  {
    name: "users-subreseller_add",
    path: "/users/subreseller_add",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/subreseller_add.vue")
  },
  {
    name: "deposits-tickets",
    path: "/deposits/tickets",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/index.vue")
  },
  {
    name: "produk-digital-e-money",
    path: "/produk-digital/e-money",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/e-money.vue")
  },
  {
    name: "users-sub-reports-ppob",
    path: "/users/sub/reports/ppob",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/ppob.vue")
  },
  {
    name: "users-subreseller_edit",
    path: "/users/subreseller_edit",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/subreseller_edit.vue")
  },
  {
    name: "airlines-rebook-reports",
    path: "/airlines/rebook-reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/rebook-reports.vue")
  },
  {
    name: "airlines-refund-reports",
    path: "/airlines/refund-reports",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/refund-reports.vue")
  },
  {
    name: "produk-digital-e-wallet",
    path: "/produk-digital/e-wallet",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/e-wallet.vue")
  },
  {
    name: "users-sub-reports-hotel",
    path: "/users/sub/reports/hotel",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/hotel.vue")
  },
  {
    name: "users-sub-reports-pelni",
    path: "/users/sub/reports/pelni",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/pelni.vue")
  },
  {
    name: "users-sub-reports-train",
    path: "/users/sub/reports/train",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/train.vue")
  },
  {
    name: "deposits-tickets-payment",
    path: "/deposits/tickets/payment",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/payment.vue")
  },
  {
    name: "airlines-multicity-rebook",
    path: "/airlines/multicity/rebook",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/multicity/rebook.vue")
  },
  {
    name: "produk-digital-pulsa-data",
    path: "/produk-digital/pulsa-data",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pulsa-data.vue")
  },
  {
    name: "produk-digital-tagihan-tv",
    path: "/produk-digital/tagihan-tv",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-tv.vue")
  },
  {
    name: "deposits-tickets-histories",
    path: "/deposits/tickets/histories",
    meta: {"middleware":["auth"]},
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/deposits/tickets/histories.vue")
  },
  {
    name: "users-sub-reports-airlines",
    path: "/users/sub/reports/airlines",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/users/sub/reports/airlines.vue")
  },
  {
    name: "produk-digital-multifinance",
    path: "/produk-digital/multifinance",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/multifinance.vue")
  },
  {
    name: "produk-digital-pln-prabayar",
    path: "/produk-digital/pln-prabayar",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pln-prabayar.vue")
  },
  {
    name: "airlines-multicity-schedules",
    path: "/airlines/multicity/schedules",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/airlines/multicity/schedules.vue")
  },
  {
    name: "produk-digital-pln-pascabayar",
    path: "/produk-digital/pln-pascabayar",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/pln-pascabayar.vue")
  },
  {
    name: "produk-digital-tagihan-telepon",
    path: "/produk-digital/tagihan-telepon",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-telepon.vue")
  },
  {
    name: "produk-digital-tagihan-internet",
    path: "/produk-digital/tagihan-internet",
    component: () => import("C:/laragon/www/pergiyuks-frontend/pages/produk-digital/tagihan-internet.vue")
  }
]